/*eslint-disable */
import React, { FC, useEffect, useContext, useState, memo } from 'react';
import UserDetailsContext from 'Context/userDetailsContext';
import injectSheet from 'react-jss';
import styleSheet from './styles';
import { Table } from 'HOC/Table';
import Lock from 'Assets/ui/lock.svg';
import { Loading } from 'Components/Loading';
import { DEFAULT_CELL_WIDTH, COLUMNS, LIST_COLUMN_CONFIG } from '../constants';
import { numberWithCommas } from 'Utils/numberWithCommas';
import { AttributePills } from 'Containers/Attributes';
import LongTextEllipsis from 'Components/LongTextEllipsis';
import { areEqual } from 'Utils/areEqual';
import { motion } from 'framer-motion';
import Pill from 'Components/Pill';
import { useRouter } from 'Utils/router';

interface Props {
  classes?: any;
  audienceData: Audience;
  tableColumns: string[];
  allColumns: string[];
  sortByDefault?: string;
  error?: any;
  loading?: any;
  onChecked?: (n: string) => void;
  onUnChecked?: (n: string) => void;
  sort?: any;
  //This will be used to determine if a checkbox has been previously checked while navigating through other pages
  isChecked?: (id: string) => boolean;
  columnConfig?: any;
  defaultCellWidth?: string;
  columns?: any;
  changeCols?: any;
  menuConfig?: {
    use?: boolean;
    hover?: boolean;
    items?: any;
    indicator?: any;
    indicatorStyles?: any;
    onChange?: (e: object) => void;
  };
  caret?: boolean;
  boxShadow?: string;
}

interface Audience {
  list: [object];
}

const addLoadAttributesInExplore = (arr: any, isFiltered: boolean) => {
  if (isFiltered) arr.push({ label: 'Load Attributes in Explore' });
};
const itemsHelper = (
  accountId,
  dataId: string,
  isFiltered: boolean,
  attr: string
) => {
  const items = [];

  if (accountId === dataId) {
    items.push({ label: 'Rename' }, { label: 'Duplicate' });
    attr != 'custom' && addLoadAttributesInExplore(items, isFiltered);
    items.push({ label: 'Permissions' }, { label: 'Delete' });
  } else {
    items.push({ label: 'Duplicate' });
    attr != 'custom' && addLoadAttributesInExplore(items, isFiltered);
  }

  return items;
};
const renderHeaders = (
  classes: any,
  tableColumns: string[],
  columnConfig: any,
  defaultCellWidth: string,
  sort?: any,
  caret?: boolean
) =>
  tableColumns.map((key: string, index: number) => {
    // Tables aren't templated, therefore custom padding needs to be implemented to meet design spec //
    const colConfigAttr = columnConfig[key],
      isSortable = (colConfigAttr && colConfigAttr.isSortable) || null,
      title = (colConfigAttr && colConfigAttr.title) || 'undefined',
      width = (colConfigAttr && colConfigAttr.width) || defaultCellWidth,
      sortKey = (colConfigAttr && colConfigAttr.sortKey) || undefined,
      doSort = isSortable && sortKey && sort;

    if (doSort) {
      //Add the sortKey if sort capabilities are being added to a column
      sort['sortKey'] = sortKey;
    }
    switch (title) {
      case 'Attributes':
        return (
          <Table.Cell
            caret={isSortable && caret}
            minWidth={width}
            key={index}
            sort={doSort ? { ...sort } : null}
          >
            <span className={classes.firstCell}>{title}</span>
          </Table.Cell>
        );
      default:
        return (
          <Table.Cell
            caret={isSortable && caret}
            minWidth={width}
            key={index}
            sort={doSort ? { ...sort } : null}
          >
            <span className={classes.firstCell}>{title}</span>
          </Table.Cell>
        );
    }
  });

/*
   currentlyHoveringRow,
   columnConfig,
   columns,
   defaultCellWidth,
   key,
  key === 'createdBy'
                ? `${data[key]} ${data['shared']}`
                : data[key],
  classes,
  data.id,
              data.filters,
              data.name,
              data.loadAttributes,
              `/inquiries/lists/${data.id}`,
              JSON.stringify(menuConfig.items)
  */
const listAttribute = (filters: string, value: string) => {
  if (filters === '{"operation":"AND"}') return <Pill text={'No Filters'} />;

  return value !== 'custom' ? (
    <AttributePills filterAttributes={value} />
  ) : (
    'Custom'
  );
};
const renderCell = (
  currentlyHoveringRow: any,
  columnConfig: any,
  columns: any,
  defaultCellWidth: string,
  cellKey: string,
  value: any,
  classes: any,
  id: any,
  filters: string,
  listName?: string,
  loadAttributes?: string,
  items?: any
) => {
  const column = columnConfig[cellKey];
  const cellWidth = column && column.width ? column.width : defaultCellWidth;

  switch (cellKey) {
    case columns.CREATED_BY: {
      let shared = value.split(' ').pop();
      let name = value.replace(/[\W]*\S+[\W]*$/, '');
      return (
        <Table.Cell key={cellKey} minWidth={cellWidth}>
          <div
            className={`${classes.firstCellBody} ${classes.createdByHolder}`}
          >
            <div className={classes.createdByName}>
              {<LongTextEllipsis value={name} />}
            </div>
            {shared === 'false' && <Lock className={classes.lock} />}
          </div>
        </Table.Cell>
      );
    }
    case columns.NAME:
      return (
        <Table.Cell key={cellKey} minWidth={cellWidth}>
          <div className={classes.firstCellBody}>{value}</div>
        </Table.Cell>
      );
    case columns.ATTRIBUTES:
      return (
        <Table.Cell
          key={cellKey}
          minWidth={cellWidth}
          display="flex"
          position={id === currentlyHoveringRow && 'sticky'}
          listName={listName}
          loadAttributes={loadAttributes}
          items={items}
        >
          <div className={classes.firstCellBodyAttributes}>
            {listAttribute(filters, value)}
          </div>
        </Table.Cell>
      );
    case columns.LEADS:
      return (
        <Table.Cell key={cellKey} minWidth={cellWidth}>
          <div className={classes.firstCell}>{numberWithCommas(value)}</div>
        </Table.Cell>
      );
    default:
      return (
        <Table.Cell key={cellKey} minWidth={cellWidth}>
          <div className={classes.firstCellBody}>{value}</div>
        </Table.Cell>
      );
  }
};

const renderRows = (
  columnConfig: any,
  columns: any,
  defaultCellWidth: string,
  list: any,
  tableColumns: string[],
  classes: any,
  currentlyHoveringRow: any,
  configMenu: any,
  setCurrentlyHoveringRow: any,
  accountId: any,
  goToLink: (location: string) => void,
) =>
  list.length === 0 ? (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Table.Row padding="0px 24px 0 33px" color="#051D39">
        [No Results]
      </Table.Row>
    </div>
  ) : (
    list.map((data: any, index: number) => {
      const menuConfig = {
        ...configMenu,
        items: itemsHelper(
          accountId,
          data.accountId,
          data.listType === 'filtered',
          data.attributes
        ),
      };

      return (
        <motion.div
          initial={{ zIndex: 0, boxShadow: '0 2px 8px 0 rgba(0,0,0,0)' }}
          transition={{ duration: 0.2 }}
          whileHover={{ zIndex: 10, boxShadow: '0 2px 8px 0 rgba(0,0,0,0.15)' }}
        >
          <Table.Row
            id={data.id}
            shared={data.shared}
            loadAttributes={data.loadAttributes}
            count={data.leads}
            onMouseEnter={(event: any) => {
              setCurrentlyHoveringRow(data.id);
            }}
            onMouseLeave={(event: any) => {
              setCurrentlyHoveringRow(null);
            }}
            onClick={() => {
              goToLink(`/inquiries/lists/${data.id}`)
            }}
            key={index}
            padding="0px 24px 0 33px"
            justifyContent={
              tableColumns.length === 6 ? 'space-around' : 'normal'
            }
            color="#051D39"
            listName={data.name}
            menuConfig={menuConfig}
            listType={data.listType}
            tableColumns={tableColumns}
          >
            {tableColumns.map((key: string) => {
              return renderCell(
                currentlyHoveringRow,
                columnConfig,
                columns,
                defaultCellWidth,
                key,
                key === 'createdBy'
                  ? `${data[key]} ${data['shared']}`
                  : data[key],
                classes,
                data.id,
                data.filters,
                data.name,
                data.loadAttributes,
                JSON.stringify(menuConfig.items)
              );
            })}
          </Table.Row>
        </motion.div>
      );
    })
  );

const List: FC<Props> = memo((props: Props) => {
  // Logged in user details //
  const userDetails = useContext(UserDetailsContext);
  const [tableWidth, setTableWidth] = useState(null);
  const [currentlyHoveringRow, setCurrentlyHoveringRow] = useState(null);
  const accountId = userDetails.accountId;

  const { push } = useRouter();
  const goToLink = (loc: string) => {
    push({ pathname: loc });
  };

  useEffect(() => {}, [props.audienceData]);
  /*
      Check to see if a Column config was passed in.  If so, use it.   
      Otherwise, use the local constants imported at the top.
      This not only allows for different configurations for the table, it allows us to use knobs to configure
      this data in storybook for better testing

      This would be a good candidate for lazy loading
    */
  const columnConfig = props.columnConfig || LIST_COLUMN_CONFIG,
    defaultCellWidth = props.defaultCellWidth || DEFAULT_CELL_WIDTH,
    columns = props.columns || COLUMNS,
    isChecked = props.isChecked;
  /* In the Table Header Row, Tables aren't templated, therefore custom padding needs to be implemented to meet design spec */

  if (!props.loading && !props.error)
    return (
      <div className={props.classes.container}>
        <Table padding="3px">
          <Table.Header changeTableWidth={(width: any) => setTableWidth(width)}>
            <Table.Row
              padding={'22px 24px 0 30px'}
              justifyContent={
                props.tableColumns.length === 6 ? 'space-around' : 'normal'
              }
            >
              {renderHeaders(
                props.classes,
                props.tableColumns,
                columnConfig,
                defaultCellWidth,
                props.sort,
                props.caret
              )}
            </Table.Row>
          </Table.Header>

          <div
            className={props.classes.bodyBackground}
            style={{ width: tableWidth }}
          >
            <Table.Body>
              {renderRows(
                columnConfig,
                columns,
                defaultCellWidth,
                props.audienceData.list,
                props.tableColumns,
                props.classes,
                currentlyHoveringRow,
                props.menuConfig,
                setCurrentlyHoveringRow,
                accountId,
                goToLink
              )}
            </Table.Body>
          </div>
        </Table>
      </div>
    );
  else
    return (
      <>
        {props.loading && <Loading />}
        {props.error && <div>{props.error}</div>}
      </>
    );
}, areEqual);

// List.defaultProps = {
// classes:{},
// sortByDefault:'',
// error: "",
// loading: false,
// onChecked: () => {},
// onUnChecked:  () => {},
// sort: '',
// isChecked: () => false,
// changeCols: [],

// caret: false,
// boxShadow:'',
// columnConfig: {},
// columns: [],

// menuConfig: {
//   use: false,
//   hover: false,
//   items: [],
//   indicator: {},
//   indicatorStyles: {},
//   onChange: () => {}
// },
// defaultCellWidth:undefined,
//};

export default injectSheet(styleSheet)(List);
